import {FC} from 'react'

import {theme} from '@/theme/theme'

import {Icon, IconProps} from './Icon'

export const FolderIcon: FC<IconProps> = ({color = theme.palette.text.default, size}) => (
  <Icon size={size}>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.39453 4.75C1.39453 3.36891 2.51344 2.25 3.89453 2.25H7.80141C8.345 2.25 8.85192 2.52193 9.15344 2.97422L10.3837 4.8196C10.4059 4.85301 10.4453 4.875 10.4877 4.875H14.3945C15.7756 4.875 16.8945 5.99391 16.8945 7.375V7.54207C18.3141 7.80468 19.2565 9.25482 18.8312 10.7038V10.7038L17.2903 15.9538C16.9779 17.0186 16.0015 17.75 14.8915 17.75H3.14816C2.17919 17.75 1.39453 16.9653 1.39453 15.9964V4.75ZM4.90246 16.25L6.8634 9.71325C6.99047 9.28952 7.38003 9 7.82153 9H16.4324C17.1001 9 17.5799 9.64089 17.3919 10.2814L15.851 15.5314C15.726 15.9576 15.3355 16.25 14.8915 16.25H4.90246ZM15.3945 7.5V7.375C15.3945 6.82234 14.9472 6.375 14.3945 6.375H10.4877C9.94571 6.375 9.43718 6.10443 9.13562 5.65165L7.90537 3.80628C7.8814 3.77032 7.84231 3.75 7.80141 3.75H3.89453C3.34187 3.75 2.89453 4.19734 2.89453 4.75V15.9964C2.89453 16.1369 3.00762 16.25 3.14816 16.25C3.2603 16.25 3.35865 16.1763 3.39033 16.0703L5.42664 9.28232V9.28232C5.74409 8.22384 6.71781 7.5 7.82153 7.5H15.3945Z"
        fillRule="evenodd"
        clipRule="evenodd"
        fill={color}
      />
    </svg>
  </Icon>
)
